import React, { useState, useEffect } from "react";
import TextInput from "../../fields/TextInput";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { MuiTelInput, matchIsValidTel } from "mui-tel-input";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  cleanFPdetail,
  forgetPassword,
  storeFPmail,
} from "../../../redux/Slice/authSlice";
import { ClipLoader } from "react-spinners";

const Index = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const forgetPW = useSelector((state) => state?.auth?.forgetpwDetail);
  const forgetpwStatus = useSelector((state) => state?.auth?.forgetpwStatus);

  const [errmsg, setErrMsg] = useState({ email: "", phoneErrMsg: "" });
  const [forgetPwDetail, setForgetPwDetail] = useState({ email: "" });
  const [phone, setPhone] = useState("");
  const [withPhone, setWithPhone] = useState(false);

  const notify = (msg) => toast(`${msg}`);

  const handleInput = (event) => {
    const { name, value } = event.target;
    setForgetPwDetail((prevFormData) => ({ ...prevFormData, [name]: value }));
    setErrMsg((prev) => ({ ...prev, [name]: "" }));
  };

  const handleChange = (newPhone) => {
    setPhone(newPhone);
    setErrMsg((prev) => ({ ...prev, phoneErrMsg: "" }));
  };

  function isValidEmail(email) {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(email);
  }

  const toggleLogin = () => {
    setWithPhone(!withPhone);
  };

  useEffect(() => {
    if (forgetPW?.success === true) {
      navigate("/otp/resetpassword");
      notify(forgetPW?.message);
      dispatch(storeFPmail(forgetPW?.data));
    }
  }, [forgetPW]);

  useEffect(() => {
    return () => {
      dispatch(cleanFPdetail());
    };
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const isPhoneValid = matchIsValidTel(phone);
    const mailValid = isValidEmail(forgetPwDetail?.email);
    let newErrMsg = {};

    if (withPhone) {
      if (!isPhoneValid)
        newErrMsg = { ...newErrMsg, phoneErrMsg: "Please Enter valid Phone" };
      setErrMsg(newErrMsg);

      if (!isPhoneValid) {
        return;
      } else {
        dispatch(
          forgetPassword({
            type: "phone",
            phoneNumber: phone,
          })
        );
      }
    } else {
      if (mailValid === false)
        newErrMsg = { ...newErrMsg, email: "Please Enter valid Mail" };
      setErrMsg(newErrMsg);

      if (mailValid === false) {
        return;
      } else {
        dispatch(
          forgetPassword({
            type: "email",
            email: forgetPwDetail?.email,
          })
        );
      }
    }

    // if (mailValid === false || !isPhoneValid) {
    //     return
    // } else {

    //     navigate('/otp');
    //     notify()
    // }
  };

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div className="container-fluid px-0">
      <div className="slider_img ">
        <div className="row mx-0 z_999">
          <div className="col-lg-4 px-0">
            <div className="login-div mx-1">
              <h2 className="font accentColor">Forget Password?</h2>
              <div className="mt-2">
                {withPhone ? (
                  <div className="">
                    <p className="accentColor mb-1 fs14">
                      Phone Number<span style={{ color: "red" }}>*</span>
                    </p>
                    <MuiTelInput
                      error={!!errmsg.phoneErrMsg}
                      defaultCountry="ZM"
                      value={phone}
                      onChange={handleChange}
                      variant="outlined"
                      size="small"
                      sx={{ width: "100%" }}
                      helperText={errmsg.phoneErrMsg}
                    />
                  </div>
                ) : (
                  <div className="">
                    <p className="accentColor mb-1 fs14">
                      Email<span style={{ color: "red" }}>*</span>
                    </p>
                    <TextInput
                      type="email"
                      id="email"
                      size="small"
                      name="email"
                      value={forgetPwDetail.email}
                      onChange={handleInput}
                      error={!!errmsg.email}
                      helperText={errmsg.email}
                      formPlaceholder="Enter Your Email"
                      shrink="false"
                      animation="true"
                      requiredStar={true}
                    />
                  </div>
                )}
                {forgetPW?.success === false ? (
                  <p className="location-err">{forgetPW?.message}</p>
                ) : null}

                <p
                  className="secondaryColor fs14 forget-pw mb-3 mt-3 pointor "
                  onClick={toggleLogin}
                >
                  {withPhone ? "Verify through Email" : "Verify through Phone"}
                </p>
                <button
                  type="submit"
                  onClick={(e) => {
                    scrollToTop();
                    handleSubmit(e);
                  }}
                  className="btn w-100 grid-class img-btn mt-3 primaryColor"
                >
                  {forgetpwStatus === "pending" ? null : "Send"}
                  <ClipLoader
                    loading={forgetpwStatus === "pending" ? true : false}
                    cssOverride={{ width: "25px", height: "25px" }}
                    color="#fff"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
